exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".progress-linear[data-v-25e54a52]{margin:0}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/User.vue"],"names":[],"mappings":"AACA,kCAAoC,QAAU,CAC7C","file":"User.vue","sourcesContent":["\n.progress-linear[data-v-25e54a52] { margin: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25e54a52","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/User.vue
// module id = 921
// module chunks = 0